import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { RequireAuth } from './components/RequireAuth.js';
import { LoginPage } from './routes/LoginPage.js';
import { SigningInPage } from './routes/SigningInPage.js';
import { AdminLoginPage } from './routes/AdminLoginPage.js';
import { AdminPage } from './routes/AdminPage.js';
import { VendorDashboardPage } from './routes/VendorDashboardPage.js';
import { SurveyPage } from './routes/SurveyPage.js';
import { NotFoundPage } from './routes/NotFoundPage.js';
import { LandingPage } from './marketing/LandingPage.js';
import { PrivacyPage } from './marketing/PrivacyPage.js';
import { ContactPage } from './marketing/ContactPage.js';

/** Reset scroll to the top on every route change — SPA navigation otherwise keeps it. */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* The marketing landing is the front door, for signed-in staff and visitors alike. */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/login" element={<LoginPage />} />
        {/* Where the emailed magic link lands; the token is redeemed only on an explicit click. */}
        <Route path="/signing-in" element={<SigningInPage />} />
        {/* The admin portal has its own username/password sign-in, separate from the magic link. */}
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route
          path="/admin/*"
          element={
            <RequireAuth requireCapability="authorSurveys" loginPath="/admin/login">
              <AdminPage />
            </RequireAuth>
          }
        />
        <Route
          path="/dashboard/*"
          element={
            <RequireAuth>
              <VendorDashboardPage />
            </RequireAuth>
          }
        />
        {/* The link employees are given: voicetovalue.co.uk/<vendorSlug>/<surveySlug> */}
        <Route path="/:vendorSlug/:surveySlug" element={<SurveyPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}
